import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

// skin
const skin = era.skin('shared/ui/components/Skeleton')

type SkeletonType =
  | 'main'
  | 'grid'
  | 'searchGrid'
  | 'category'
  | 'bundle'
  | 'epg'
  | 'catchups'
  | 'catchupsGridWithPrograms'
  | 'categoriesTabs'

const skeletonNamesByPageTypes: Record<SkeletonType, string> = {
  main: 'skeleton',
  grid: 'skeletonGrid',
  searchGrid: 'skeletonSearchGrid',
  category: 'skeletonCategory',
  bundle: 'skeletonBundle',
  epg: 'skeletonEpg',
  catchups: 'skeletonCatchups',
  catchupsGridWithPrograms: 'catchupsGridWithPrograms',
  categoriesTabs: 'skeletonCategoriesTabs',
} as const

type SkeletonProps = {
  pageType: SkeletonType
  children: React.ReactNode
  isLoading?: boolean
}

Skeleton.displayName = 'Skeleton'
export function Skeleton({
  pageType,
  children,
  isLoading,
}: SkeletonProps): JSX.Element | null {
  const skeletonName = skeletonNamesByPageTypes[pageType]

  const isSkeletonShown = skeletonName && isLoading

  if (isSkeletonShown)
    return <ui.RenderSkin from={skin} name={skeletonName} key={skeletonName} />

  return <>{children}</>
}
